import { ModalConfirmation, ModalConfirmationProps, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

interface CreateAccountFromTemplateConfirmationModalProps extends ModalConfirmationProps {
  accountNumber: number | null
  isSubmitting: boolean
}

export const CreateAccountFromTemplateConfirmationModal = ({
  accountNumber,
  isSubmitting,
  ...props
}: CreateAccountFromTemplateConfirmationModalProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <ModalConfirmation
      {...props}
      cancelLabel={t('cancel')}
      message={
        <Text variant="bodyMD">
          <Trans
            components={{ strong: <strong /> }}
            i18nKey="coa.account_from_base_form.create_confirmation.message"
            values={{ accountNumber }}
          />
        </Text>
      }
      okLabel={t('coa.account_from_base_form.create_confirmation.confirm_button')}
      okLoading={isSubmitting}
      title={t('coa.account_from_base_form.create_confirmation.title')}
    />
  )
}
